export const FEATURES = {
  // essential
  ESTATE_PLAN: 'estatePlan',
  ASSISTANT_AND_RECOMMENDATIONS: 'assistantAndRecommendations',
  BENEFICIARY_CONTACTS: 'beneficiaryContacts',
  SUPPORTS_SECTION: 'supportSsection',
  TRUSTEE_CONTACTS: 'trusteeContacts',
  // optional
  GENERATE_AND_EXPORT_DOCUMENTS: 'generateAndExportDocuments',
  NOTIFICATIONS: 'notifications',
  REFERRAL_PROGRAM: 'referralProgram',
  PLAN_AND_UPGRADING: 'planAndUpgrading',
  REMINDERS: 'reminders',
  SECURITY_KEY: 'securityKey',
  TWO_FA: 'twoFA',
  LANGUAGE_SWITCHER: 'languageSwitcher',
  EMERGENCY_ACCESS: 'emergencyAccess',
};

const F = FEATURES;

export const FEATURE_TOGGLE = {
  [F.GENERATE_AND_EXPORT_DOCUMENTS]: {
    active: true,
    name: F.GENERATE_AND_EXPORT_DOCUMENTS,
  },
  [F.NOTIFICATIONS]: {
    active: true,
    name: F.NOTIFICATIONS,
  },
  [F.REFERRAL_PROGRAM]: {
    active: true,
    name: F.REFERRAL_PROGRAM,
  },
  [F.PLAN_AND_UPGRADING]: {
    active: true,
    name: F.PLAN_AND_UPGRADING,
  },
  [F.REMINDERS]: {
    active: true,
    name: F.REMINDERS,
  },
  [F.SECURITY_KEY]: {
    active: true,
    name: F.SECURITY_KEY,
  },
  [F.TWO_FA]: {
    active: true,
    name: F.TWO_FA,
  },
  [F.LANGUAGE_SWITCHER]: {
    active: true,
    name: F.LANGUAGE_SWITCHER,
  },
  [F.EMERGENCY_ACCESS]: {
    active: true,
    name: F.EMERGENCY_ACCESS,
  },
};
